import { onError } from 'apollo-link-error'

export function redirectOnError (redirects) {
  return onError(({ graphQLErrors, networkError, operation, forward }) => {
    if (networkError && typeof redirects[networkError.statusCode] !== 'undefined') {
      window.location.href = redirects[networkError.statusCode]
    }
  })
}
